import { generateFullName } from '@/entities/Person/PersonHelpers'

import { ChatUser, ChatUserResource } from './ChatUser'

export const transformToChatUser = (resource: ChatUserResource): ChatUser => ({
    id: resource.uuid,
    firstname: resource.firstName,
    affix: resource.affix ?? undefined,
    lastname: resource.lastName,
    fullName: generateFullName(resource.firstName, resource.lastName, resource.affix ?? undefined),
    // The API types this as a non-nullable string, but it is not populated for every user (yet).
    streamUserId: resource.streamUserId || null,
})
